import { CheckboxCard } from '@1trading/react/components/ui/checkbox';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NoneCheckboxGroupNoneCheckbox, NoneCheckboxGroupNonNoneCheckbox } from '@/components/ui/none-checkbox-group';
import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import type { AppropriatenessTestFuturesKnowledgeStatements } from '@/features/futures/schemas/appropriateness-test';
import { DONT_KNOW_VALUE, FUTURES_APPROPRIATENESS_FUTURES_KNOWLEDGE_STATEMENTS_ANSWERS } from '@/services/api/profile/futures-appropriateness';

const FuturesAppropriatenessTestFieldsetFuturesKnowledgeStatementsLegend = () => {
  const { t } = useTranslation();

  return (
    <PageHeading asChild>
      <legend>
        <PageHeadingTitle>{t('FuturesAppropriatenessAssessment.futuresKnowledgeStatements.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('FuturesAppropriatenessAssessment.futuresKnowledgeStatements.description')}</PageHeadingDescription>
      </legend>
    </PageHeading>
  );
};
FuturesAppropriatenessTestFieldsetFuturesKnowledgeStatementsLegend.displayName = 'FuturesAppropriatenessTestFieldsetFuturesKnowledgeStatementsLegend';

const FuturesAppropriatenessTestFieldsetFuturesKnowledgeStatements = () => {
  const form = useFormContext<Partial<AppropriatenessTestFuturesKnowledgeStatements>>();
  const { t } = useTranslation();

  return (
    <FormField
      name="futuresKnowledgeStatements"
      control={form.control}
      render={() => (
        <FormItem>
          <FormControl aria-label={t('FuturesAppropriatenessAssessment.futuresKnowledgeStatements.title')}>
            {/* biome-ignore lint/a11y/useSemanticElements: Makeshift checkboxgroup since it's not a native role */}
            <div className="space-y-4" role="group">
              {FUTURES_APPROPRIATENESS_FUTURES_KNOWLEDGE_STATEMENTS_ANSWERS.filter((answer) => answer !== DONT_KNOW_VALUE).map((answer) => (
                <FormField
                  key={answer}
                  control={form.control}
                  name="futuresKnowledgeStatements"
                  render={({ field }) => (
                    <FormItem key={answer}>
                      <CheckboxCard variant="outline">
                        <FormControl>
                          <NoneCheckboxGroupNonNoneCheckbox answer={answer} field={field} noneValue={DONT_KNOW_VALUE} variant="cards" />
                        </FormControl>
                        <FormLabel contained>{t(`FuturesAppropriatenessAssessment.futuresKnowledgeStatements.options.${answer}`)}</FormLabel>
                      </CheckboxCard>
                    </FormItem>
                  )}
                />
              ))}
              <p>{t('fundamentals.orSelect')}:</p>
              <FormField
                control={form.control}
                name="futuresKnowledgeStatements"
                render={({ field }) => (
                  <FormItem>
                    <CheckboxCard variant="outline">
                      <FormControl>
                        <NoneCheckboxGroupNoneCheckbox field={field} noneValue={DONT_KNOW_VALUE} variant="cards" />
                      </FormControl>
                      <FormLabel contained>{t(`FuturesAppropriatenessAssessment.futuresKnowledgeStatements.options.${DONT_KNOW_VALUE}`)}</FormLabel>
                    </CheckboxCard>
                  </FormItem>
                )}
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
FuturesAppropriatenessTestFieldsetFuturesKnowledgeStatements.displayName = 'FuturesAppropriatenessTestFieldsetFuturesKnowledgeStatements';
FuturesAppropriatenessTestFieldsetFuturesKnowledgeStatements.validateOnNavigation = true;

export { FuturesAppropriatenessTestFieldsetFuturesKnowledgeStatements, FuturesAppropriatenessTestFieldsetFuturesKnowledgeStatementsLegend };
